import React from 'react';
import PropTypes from 'prop-types';

import MSearchField from '../molecules/fields/_molecules.search-field';
import MDropDown from '../molecules/fields/_molecules.drop-down';
import MTagList from '../molecules/_molecules.tag-list';
import AButton from '../atoms/_atoms.button';
// TODO can't finish until client returns the filters
export default class OProductFilters extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			search: '',
			categorie1: '',
			categorie2: '',
			categorie3: '',
			categorie4: '',
		};

		this.bindHandles();
	}

	bindHandles() {
		this.handleSearch = this.handleSearch.bind(this);
		this.handleSearchChange = this.handleSearchChange.bind(this);
		this.handleCategorieChange = this.handleCategorieChange.bind(this);
	}

	handleSearch(value) {
		if (this.props.onSearch) {
			this.props.onSearch(value);
		}
	}
	handleSearchChange(value) {
		if (this.props.onSearchChange) {
			this.props.onSearchChange(value);
		}
	}

	handleCategorieChange(value) {
		if (this.props.onSelect) {
			this.props.onSelect(value);
		}
	}

	render() {
		return (
			<section className="o-filter-product">
				<MSearchField
					id="productSearch"
					label=""
					onClick={this.handleSearch}
					onChange={this.handleSearchChange}
				/>
				{/* <div className="o-filter-product--dropdown">
					<MDropDown
						id="dd"
						label=""
						items={[]}
						onChange={this.handleCategorieChange}
					/>
					<MDropDown
						id="dd"
						label=""
						items={[]}
						onChange={this.handleCategorieChange}
					/>
					<MDropDown
						id="dd"
						label=""
						items={[]}
						onChange={this.handleCategorieChange}
					/>
					<MDropDown
						id="dd"
						label=""
						items={[]}
						onChange={this.handleCategorieChange}
					/>
				</div>
				<div className="o-filter-product--tags">
					<MTagList
						items={[]}
						onClick={this.props.onRemoveFilter}
					/>
					<AButton
						value="FORM.SEARCH"
						onClick={this.props.onFilter}
					/>
				</div> */}
			</section>
		);
	}
}

OProductFilters.propTypes = {
	onSearchChange: PropTypes.func.isRequired,
	onSearch: PropTypes.func.isRequired,
	onFilter: PropTypes.func,
	onRemoveFilter: PropTypes.func,
};

OProductFilters.defaultProps = {
	onFilter: undefined,
	onRemoveFilter: undefined,
};




// WEBPACK FOOTER //
// ./src/components/organisme/_organisme.product-filters.js